export default "<iframe class='schedulerOverlayIframe'>\n    <js-templateNonce></js-templateNonce>\n</iframe>\n\n";